var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRow',[_c('VCol',{attrs:{"cols":"12"}},[_c('VSelect',{attrs:{"dense":"","outlined":"","hide-details":"","label":"Select Role","items":_vm.validRoles(_vm.$team.roles, ['organization-admin'])},model:{value:(_vm.form.currentRole),callback:function ($$v) {_vm.$set(_vm.form, "currentRole", $$v)},expression:"form.currentRole"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }